import { Col, Row } from "@intech/web-ui";
import styled from "styled-components";

export const CenteredColumn = styled(Col)`
  justify-content: center;
  align-self: center;
`;

export const SmallColumn = styled(Col)`
  width: 1px;
`;

export const LeftColumn = styled(Col)`
  justify-content: left;
  align-self: center;
`;

